import { useQuery } from "@apollo/client/react";
import type { ItemType } from "@jasper/client-models";
import { GetAnatomyItemShadesAndMaterialsDocument } from "../../gql/generated/graphql";

export interface ItemMaterial {
  value: string;
  label: string;
}

export interface ItemShadeType {
  value: string;
  label: string;
}

export interface ItemShade {
  value: string;
  label: string;
  shadeType?: string;
}

interface Props {
  itemType: ItemType;
}

export const useItemMaterialsByItemType = ({
  itemType,
}: Props): {
  isLoading: boolean;
  itemMaterials: ItemMaterial[];
  itemShadeTypes: ItemShadeType[];
  itemShades: ItemShade[];
} => {
  const { data, loading } = useQuery(GetAnatomyItemShadesAndMaterialsDocument, {
    variables: {
      itemType,
    },
  });

  const itemMaterials: ItemMaterial[] =
    data?.findItemMaterialsByItemType.map(({ id, name }) => ({
      label: name,
      value: id,
    })) ?? [];

  const itemShadeTypes = [
    ...new Set<string>(
      data?.findItemShadesByItemType
        .filter(item => !!item.shadeType)
        .map(({ shadeType }) => shadeType!) ?? []
    ),
  ].map(shadeType => ({
    label: shadeType?.replaceAll("_", " "),
    value: shadeType,
  }));

  const itemShades: ItemShade[] =
    data?.findItemShadesByItemType.map(({ id, name, shadeType }) => ({
      label: name,
      value: id,
      shadeType: shadeType ?? undefined,
    })) ?? [];

  return {
    itemMaterials,
    itemShades,
    itemShadeTypes,
    isLoading: loading,
  };
};
